import { useEffect, useState } from 'react';
import { NEONVERSE } from '../constants';

const links = [
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#how-it-works', label: 'How It Works' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
  { href: '#contact', label: 'Start' },
];

const NeonNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`nv-nav${scrolled ? ' nv-nav--scrolled' : ''}`}>
      <div className="nv-container nv-nav__inner">
        <a
          href="#top"
          className="nv-nav__brand"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          Neon <span>Verse</span>
        </a>

        <nav aria-label="Primary">
          <ul className="nv-nav__links">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={(e) => {
                    e.preventDefault();
                    go(l.href);
                  }}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <a
          href="#contact"
          className="nv-btn nv-btn--primary nv-nav__cta"
          onClick={(e) => {
            e.preventDefault();
            go('#contact');
          }}
        >
          {NEONVERSE.hero.primaryCta}
        </a>

        <button
          type="button"
          className="nv-nav__menu-btn"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`nv-container nv-nav__drawer${open ? ' open' : ''}`}>
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            onClick={(e) => {
              e.preventDefault();
              go(l.href);
            }}
          >
            {l.label}
          </a>
        ))}
        <a
          href="#contact"
          className="nv-btn nv-btn--primary"
          style={{ alignSelf: 'flex-start', marginTop: '0.5rem' }}
          onClick={(e) => {
            e.preventDefault();
            go('#contact');
          }}
        >
          {NEONVERSE.hero.primaryCta}
        </a>
      </div>
    </header>
  );
};

export default NeonNav;
